import { Controller } from "@hotwired/stimulus"
import { getDefaultMenuNames } from "../constants/default_menu_names"
import { getRandomMenuName } from "../constants/random_menu_names"

// Stimulus controller for random menu name input
export default class extends Controller {
  connect() {
    // No auto-fill on connect - start with empty fields
  }

  // Handler for individual random button clicks
  fillRandomName(event: Event) {
    event.preventDefault()
    const button = event.currentTarget as HTMLElement
    const inputGroup = button.closest('.p-menu__menu-item')
    if (!inputGroup) return

    // Collect current menu names (line1) as exclusion list
    const excludeNames = this.getAllMenuNames()

    // Get a non-duplicate random name
    const [line1, line2] = getRandomMenuName(excludeNames)

    const line1Input = inputGroup.querySelector<HTMLInputElement>('input[name="menu_names_line1[]"]')
    const line2Input = inputGroup.querySelector<HTMLInputElement>('input[name="menu_names_line2[]"]')

    if (line1Input) {
      line1Input.value = line1
      line1Input.dispatchEvent(new Event('input', { bubbles: true }))
    }
    if (line2Input) {
      line2Input.value = line2 || ''
      line2Input.dispatchEvent(new Event('input', { bubbles: true }))
    }
  }

  // Collect all menu names (line1) including the current one
  private getAllMenuNames(): string[] {
    const allInputGroups = this.element.querySelectorAll('.p-menu__menu-item')
    const names: string[] = []

    allInputGroups.forEach((group) => {
      const line1Input = group.querySelector<HTMLInputElement>('input[name="menu_names_line1[]"]')
      if (line1Input && line1Input.value.trim()) {
        names.push(line1Input.value.trim())
      }
    })

    return names
  }

  // Check if all input fields are empty
  private hasNoInputValues(): boolean {
    const line1Inputs = this.element.querySelectorAll<HTMLInputElement>(
      'input[name="menu_names_line1[]"]'
    )
    const line2Inputs = this.element.querySelectorAll<HTMLInputElement>(
      'input[name="menu_names_line2[]"]'
    )

    for (const input of line1Inputs) {
      if (input.value.trim() !== '') {
        return false
      }
    }

    for (const input of line2Inputs) {
      if (input.value.trim() !== '') {
        return false
      }
    }

    return true
  }

  // Fill all menu names with default values (for initial display)
  private fillAllDefaultNames() {
    const defaultNames = getDefaultMenuNames()

    const line1Inputs = this.element.querySelectorAll<HTMLInputElement>(
      'input[name="menu_names_line1[]"]'
    )
    const line2Inputs = this.element.querySelectorAll<HTMLInputElement>(
      'input[name="menu_names_line2[]"]'
    )

    defaultNames.forEach(([line1, line2], index) => {
      if (line1Inputs[index]) {
        line1Inputs[index].value = line1
        line1Inputs[index].dispatchEvent(new Event('input', { bubbles: true }))
      }
      if (line2Inputs[index]) {
        line2Inputs[index].value = line2 || ''
        line2Inputs[index].dispatchEvent(new Event('input', { bubbles: true }))
      }
    })
  }
}
